// src/components/LogLevelIndicator.js
import React from "react";

function LogLevelIndicator({ level, count, label, labelOnSide }) {
  var color;
  switch (level) {
    case "ERROR":
      color = "bg-burnt-sienna";
      break;
    case "WARNING":
      color = "bg-sunset";
      break;
    case "INFO":
      color = "bg-delft-blue";
      break;
    case "DEBUG":
      color = "bg-cambridge-blue";
      break;
    default:
      color = "bg-gray-400";
  }

  return (
    <div
      className={`flex ${
        labelOnSide ? "flex-row" : "flex-col"
      } items-center gap-2`}
    >
      <div
        className={`w-8 h-8 rounded-full ${color} flex items-center justify-center text-eggshell font-bold shadow-md`}
      >
        {count}
      </div>
      <p className="text-sm text-gray-600">{label}</p>
    </div>
  );
}

export default LogLevelIndicator;
